import { render } from "./OperFactBkCompareReport.vue?vue&type=template&id=78f5ffe1&scoped=true"
import script from "./OperFactBkCompareReport.vue?vue&type=script&lang=js"
export * from "./OperFactBkCompareReport.vue?vue&type=script&lang=js"

import "./OperFactBkCompareReport.vue?vue&type=style&index=0&id=78f5ffe1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f5ffe1"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QBanner,QLinearProgress,QInput,QIcon,QCard,QCardSection,QField});
